// extracted by mini-css-extract-plugin
export var cards = "SectorsDropdown-module--cards--02302";
export var dropdown = "SectorsDropdown-module--dropdown--acd05";
export var dropdownContent = "SectorsDropdown-module--dropdown-content--e5214";
export var hasSubmenu = "SectorsDropdown-module--has-submenu--f75d4";
export var icon = "SectorsDropdown-module--icon--1856a";
export var iconWrapper = "SectorsDropdown-module--icon-wrapper--25c92";
export var isOpen = "SectorsDropdown-module--is-open--1230a";
export var noCards = "SectorsDropdown-module--no-cards--21d4e";
export var sectorsDropdown = "SectorsDropdown-module--sectors-dropdown--bcb48";
export var sectorsLink = "SectorsDropdown-module--sectors-link--f311e";
export var submenu = "SectorsDropdown-module--submenu--0eba7";
export var submenuWrapper = "SectorsDropdown-module--submenu-wrapper--a4870";